/* Jamal Al Muhra — recently viewed (localStorage, PDP strip). */
(function () {
  var KEY = 'jam_recent';
  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (_) { return []; } }
  function currentHandle() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  var handle = currentHandle();
  if (handle) {
    var list = read().filter(function (h) { return h !== handle; });
    list.unshift(handle);
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, 12))); } catch (_) {}
  }
  function render() {
    var wrap = document.querySelector('[data-jam-recent]');
    if (!wrap) return;
    var grid = wrap.querySelector('[data-jam-recent-grid]');
    var root = (wrap.dataset.localeRoot || '').replace(/\/$/, '');
    var locale = root === '/ar' ? 'ar' : 'en';
    var items = read().filter(function (h) { return h !== handle; }).slice(0, 6);
    if (!items.length) return;
    var pending = items.length;
    items.forEach(function (h) {
      fetch(root + '/products/' + h + '.js')
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (p) {
          var a = document.createElement('a');
          a.className = 'jam-recent__card';
          a.href = root + '/products/' + h;
          var media = document.createElement('span');
          media.className = 'jam-recent__media';
          if (p.featured_image) {
            var img = document.createElement('img');
            img.src = p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=360';
            img.alt = ''; img.loading = 'lazy';
            media.appendChild(img);
          }
          var name = document.createElement('span');
          name.className = 'jam-recent__name';
          name.textContent = p.title.split('|')[0].trim();
          var price = document.createElement('span');
          price.className = 'jam-recent__price';
          var amount = (p.price / 100).toLocaleString(locale === 'ar' ? 'ar-AE' : 'en-GB', { minimumFractionDigits: 2 });
          var dhs = document.createElement('span'); dhs.className = 'jam-dhs'; dhs.textContent = 'AED';
          price.textContent = '';
          price.appendChild(dhs);
          price.appendChild(document.createTextNode(' ' + amount));
          a.appendChild(media); a.appendChild(name); a.appendChild(price);
          grid.appendChild(a);
          wrap.hidden = false;
        })
        .catch(function () {})
        .finally && null;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render);
  else render();
})();
